import { useState } from 'react';
import moment from 'moment';
import { ISEAMSAdvisoryProperties, MissionFeatureCollection } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties';
import { AdvisoryLink } from './AdvisoryLink';
import { formatLocalTime } from '../../support/helpers/format';
import { AnchorButton } from '../../components/button/AnchorButton';

export const SEAMSAdvisory = (props: ICompositeAdvisoryProperties<ISEAMSAdvisoryProperties>  & { mission: MissionFeatureCollection }) => {

    const [showMessage, setShowMessage] = useState(false);

    if (props.advisoryType !== 'block') {
        return null;
    }

    const mission = props.mission.getMissionRadius().properties;

    const events: {venue: string, start: string, end?: string}[] = [];
    for (const a of props.advisories) {
        a.eventStartTimes.forEach((eventStart, idx) => {
            const eventEnd = a.eventEndTimes[idx];
            const nextStart = a.eventStartTimes[idx + 1];
            const overrun = (a.IS_ACTIVE === 1 && moment().isAfter(eventEnd) && (!nextStart || moment().isBefore(nextStart)));
            const start = formatLocalTime({ time: eventStart, location: mission.center });
            const end = overrun ? undefined : formatLocalTime({ time: eventEnd, location: mission.center });
            events.push({
                venue: a.VENUE,
                start,
                end
            });
        });
    }

    return (
        <SecondaryWarningAdvisory header="Sporting Event Flight Restriction" advisoryType="block">
            <>
                <p>
                    <span>Your mission is within <strong>3&nbsp;NM</strong> of </span>
                    {events.map((event, idx) => (
                        <span key={`event-${idx}`}>
                            {idx > 0 && ', and '}
                            <b>{event.venue}</b> where there is an event
                            {event.end ? (
                                <> from <b>{event.start}</b> to <b>{event.end}</b></>
                            ) : (
                                <> in progress from <b>{event.start}</b></>
                            )}
                        </span>
                    ))}
                    .
                    <> Flights are restricted from <strong>1&nbsp;hour before</strong> until <strong>1&nbsp;hour after</strong> a qualifying event. </>
                    {!showMessage &&
                        <AnchorButton onClick={() => setShowMessage(true)}>Show SEAMS Message</AnchorButton>
                    }
                </p>
                {showMessage &&
                    <p>
                        <i>Flight operations within 3 NM of an FAA-designated stadium or sporting venue are restricted at this time, please
                        check <AdvisoryLink text="SEAMS" url="https://services1.arcgis.com/n4Ot9Qz0t5espY4s/arcgis/rest/services/SEAMS_Production_View/FeatureServer" /> for
                        information regarding when this restriction will be lifted. </i>
                        <AnchorButton onClick={() => setShowMessage(false)}>Hide SEAMS Message</AnchorButton>
                    </p>
                }
                <p>
                    <AdvisoryLink
                        text="Drones Are Prohibited In and Around Stadiums"
                        url="https://www.faa.gov/uas/resources/community_engagement/no_drone_zone/stadiums"
                    />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
